export type TAxonUserData = {
  user_id?: string
  email?: string
}

export const getAxonUserData = (
  userId?: string | null,
  email?: string | null,
): TAxonUserData => {
  const normalizedEmail = email?.trim().toLowerCase() || undefined

  return {
    ...(userId ? { user_id: userId } : {}),
    ...(normalizedEmail ? { email: normalizedEmail } : {}),
  }
}
